<template>
    <div>
        <div class="vx-row mt-6">

            <div class="vx-col w-full" v-if="session.shaka_usage < 3">
                <vx-card title="Command">
                    <p>{{session.command}}</p>
                </vx-card>
            </div>

            <div class="vx-col w-full mt-3" v-if="session.shaka_usage > 0">
                <vx-card title="Shaka command">
                    <p>{{session.shaka_command}}</p>
                </vx-card>
            </div>

            <div class="vx-col lg:w-1/2 w-full mt-3">
                <vx-card id="metricsFPSDiv" class="vs-con-loading__container">
                    <vue-apex-charts type="line" height="350" :options="getChartOptions('FPS', '#7367F0')" :series="metricsFPS"/>
                </vx-card>
            </div>

            <div class="vx-col lg:w-1/2 w-full mt-3">
                <vx-card id="metricsStreamDifferenceDiv" class="vs-con-loading__container">
                    <vue-apex-charts type="line" height="350" :options="getChartOptions('Stream time difference', '#FF9F43')" :series="metricsStreamDifference"/>
                </vx-card>
            </div>

            <div class="vx-col lg:w-1/2 w-full mt-3">
                <vx-card id="metricsBitrateDiv" class="vs-con-loading__container">
                    <vue-apex-charts type="line" height="350" :options="getChartOptions('Bitrate', '#28C76F')" :series="metricsBitrate"/>
                </vx-card>
            </div>

            <div class="vx-col lg:w-1/2 w-full mt-3">
                <vx-card id="metricsSpeedDiv" class="vs-con-loading__container">
                    <vue-apex-charts type="line" height="350" :options="getChartOptions('Speed', '#EA5455')" :series="metricsSpeed"/>
                </vx-card>
            </div>

            <div class="vx-col w-full mt-3">
                <vx-card title="Logs" id="logsDiv" class="vs-con-loading__container">
                    <template slot="actions">
                        <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                            <small class="flex cursor-pointer">
                                <span>{{logTimes[selectedLogDuration]}}</span>
                                <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                            </small>
                            <vs-dropdown-menu class="w-48">
                                <vs-dropdown-item @click="selectedLogDuration = -1">Last 25 lines</vs-dropdown-item>
                                <vs-dropdown-item @click="selectedLogDuration = 0">Full logs</vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>

                        <feather-icon icon="RefreshCwIcon" @click="loadSessionLogs()"></feather-icon>
                    </template>

                    <p id="logContainer" style="white-space: pre-wrap; font-family: monospace; max-height: 550px; overflow: scroll">{{logs}}</p>
                </vx-card>
            </div>

            <div class="vx-col w-full mt-3">
                <vx-card title="Checker">
                    <table class="simple-table">
                        <tr>
                            <td class="font-semibold">Enabled:</td>
                            <td v-if="session.checker_enabled"><vs-chip color="success">Yes</vs-chip></td>
                            <td v-else><vs-chip color="danger">No</vs-chip></td>
                        </tr>
                        <tr v-if="session.checker_enabled">
                            <td class="font-semibold">Check HLS files:</td>
                            <td v-if="session.check_files"><vs-chip color="success">Yes</vs-chip></td>
                            <td v-else><vs-chip color="danger">No</vs-chip></td>
                        </tr>
                        <tr v-if="session.checker_enabled">
                            <td class="font-semibold">Command:</td>
                            <td>{{ session.checker_command }}</td>
                        </tr>

                    </table>

                </vx-card>
            </div>

        </div>
    </div>

</template>
<script>

    import VueApexCharts from 'vue-apexcharts'

    export default {
        components: {
            VueApexCharts
        },
        data() {
            return {

                session: {
                    command: '',
                    checker_enabled: false,
                    checker_command: '',
                    check_files: false
                },

                selectedLogDuration: -1,

                logs: '',
                logTimes: {
                    '-1': 'Last 25 lines',
                    0: 'Full logs'
                },

                metricsFPS: [],
                metricsBitrate: [],
                metricsSpeed: [],
                metricsStreamDifference: []
            }
        },
        methods: {
            loadData() {
                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/worker_channel/' + this.$route.params.id + '/session/' + this.$route.params.session_id)
                loadPromise.then(function(response) {
                    thisIns.session = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                this.loadSessionLogs()
                this.loadInitialMetrics()
            },
            loadSessionLogs() {
                this.$vs.loading({
                    container: '#logsDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/worker_channel/' + this.$route.params.id + '/session/' + this.$route.params.session_id + '/logs/' + this.selectedLogDuration)
                loadPromise.then(function(response) {
                    thisIns.logs = response.data
                    const logContainer = thisIns.$el.querySelector('#logContainer')
                    logContainer.scrollTop = logContainer.scrollHeight
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                loadPromise.finally(function() {
                    thisIns.$vs.loading.close('#logsDiv > .con-vs-loading')
                })
            },
            loadInitialMetrics() {
                this.$vs.loading({
                    container: '#metricsFPSDiv',
                    type: 'corners',
                    scale: 0.7
                })

                this.$vs.loading({
                    container: '#metricsBitrateDiv',
                    type: 'corners',
                    scale: 0.7
                })

                this.$vs.loading({
                    container: '#metricsSpeedDiv',
                    type: 'corners',
                    scale: 0.7
                })

                this.$vs.loading({
                    container: '#metricsStreamDifferenceDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/worker_channel/' + this.$route.params.id + '/session/' + this.$route.params.session_id + '/metrics/-1')
                loadPromise.then(function(response) {
                    thisIns.metricsFPS = [{ name: 'FPS', data: JSON.parse(JSON.stringify(response.data.fps)) }]
                    thisIns.metricsBitrate = [{ name: 'Bitrate', data: response.data.bitrate }]
                    thisIns.metricsSpeed = [{ name: 'Speed', data: response.data.speed }]
                    thisIns.metricsStreamDifference = [{ name: 'Stream time difference', data: response.data.stream_difference }]
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                loadPromise.finally(function() {
                    thisIns.$vs.loading.close('#metricsFPSDiv > .con-vs-loading')
                    thisIns.$vs.loading.close('#metricsBitrateDiv > .con-vs-loading')
                    thisIns.$vs.loading.close('#metricsSpeedDiv > .con-vs-loading')
                    thisIns.$vs.loading.close('#metricsStreamDifferenceDiv > .con-vs-loading')
                })
            },
            getChartOptions(title, color) {
                return {
                    colors: [color],
                    xaxis: {
                        type: 'datetime',
                        tickAmount: 6,
                        labels: {
                            datetimeUTC: false
                        }
                    },
                    tooltip: {
                        x: {
                            format: 'dd/MM/yyyy HH:mm:ss'
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'straight'
                    },
                    title: {
                        text: title,
                        align: 'left'
                    },
                    chart: {
                        zoom: {
                            enabled: true,
                            type: 'x',
                            autoScaleYaxis: true
                        }
                    }
                }
            }
        },
        watch: {
            selectedLogDuration() {
                this.loadSessionLogs()
            }
        },
        mounted() {
            this.loadData()
        }
    }

</script>
<style lang="scss">
    #avatar-col {
        width: 10rem;
    }

    .simple-table {
        td {
            vertical-align: top;
            min-width: 170px;
            padding-bottom: .8rem;
            word-break: break-all;

            @media screen and (max-width:370px) {
                display: block;
            }
        }
    }

    @media screen and (min-width:1201px) and (max-width:1211px),
    only screen and (min-width:636px) and (max-width:991px) {
        #account-info-col-1 {
            width: calc(100% - 12rem) !important;
        }

    }

</style>
